import { render, staticRenderFns } from "./liveRoomGoods.vue?vue&type=template&id=0526eb6c&"
import script from "./liveRoomGoods.vue?vue&type=script&lang=js&"
export * from "./liveRoomGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports